import type { SVGProps } from 'react';

const SvgLoaderCircleDoneLegacy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 3c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9m0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7"
    />
    <path
      fill="currentcolor"
      d="M14.29 9.29 11 12.58l-1.29-1.29A.996.996 0 1 0 8.3 12.7l2 2c.2.2.45.29.71.29s.51-.1.71-.29l4-4a.996.996 0 1 0-1.41-1.41z"
    />
  </svg>
);
export default SvgLoaderCircleDoneLegacy;
